export enum ItemQuestionAnswersTypeEnum {
  singleSelectAnswerEnum = 10,
  matrixMultiSelectAnswerEnum = 20,
  matrixHeaderAnswerEnum = 30,
  dropdownAnswerEnum = 40,
  ratingAnswerEnum = 50, // ranking
  openEndedAnswerEnum = 60,
}
